import React from 'react';
import { Route } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Logs from './Logs/AvpLogs';
import AvpInitiateForm from './initiateForm/AvpInitiateForm';
import AvpDetailPage from './Logs/detail/AvpdetailPage';
import Violations from './Violations/Violations';
import ViolationDetail from './Violations/Detail';
import DefectLog from './Defects/DefectLog';
import DefectDetail from './Defects/DefectDetail';
import AvpReOpen from './initiateForm/AvpReOpen';
import AvpRenewal from './initiateForm/AvpRenewal';

const AdpLayout = ({ match }) => (
  <>
    <Route exact path={`${match.url}/logs`} component={Logs} />
    <Route exact path={`${match.url}/initiate/application`} component={AvpInitiateForm} />
    <Route exact path={`${match.url}/detail/:id`} component={AvpDetailPage} />
    <Route exact path={`${match.url}/detail/:id/renewal`} component={AvpRenewal} />
    <Route exact path={`${match.url}/detail/:id/reapply`} component={AvpReOpen} />
    <Route exact path={`${match.url}/violations`} component={Violations} />
    <Route exact path={`${match.url}/violations/detail/:id`} component={ViolationDetail} />
    <Route exact path={`${match.url}/vehicle_defect`} component={DefectLog} />
    <Route exact path={`${match.url}/vehicle_defect/detail/:id`} component={DefectDetail} />
    <Route exact path={`${match.url}/draft/application/:id`} component={AvpInitiateForm} />
  </>
);

export default injectIntl(AdpLayout);
